import { Funcionario, funcionario } from 'service/api'

import { CreateSlice } from './index'

export type EmployeeState = {
    employeeId: number
    employeeIds: number[]
    employee: Funcionario | null
    incluirDemitidos: boolean
    setEmployeeId: (id: number) => void
    setEmployeeIds: (ids: number[]) => void
    setIncluirDemitidos: (incluir: boolean) => void
}

export const createEmployeeSlice: CreateSlice<EmployeeState> = (set, get) => ({
    employeeId: -1,
    employeeIds: [],
    employee: null,
    incluirDemitidos: false,
    setEmployeeId: (id: number) => {
        if (get().employeeId === id) return
        set({ employeeId: id, employee: null })

        // `-1` limpa a seleção, não há o que buscar
        if (id <= 0) return

        funcionario.getById(id).then(
            fetched => {
                if (get().employeeId === id) {
                    set({ employee: fetched as Funcionario })
                }
            },
            () => {
                // React query cuida do erro
                void 0
            },
        )
    },
    setEmployeeIds: (ids: number[]) => {
        const first = ids[0] ?? -1
        set({ employeeIds: ids, employeeId: first })
    },
    setIncluirDemitidos: (incluir: boolean) => {
        set({ incluirDemitidos: incluir })
    },
})
